export interface Toast {
  id: number;
  title: string;
  message: string;
  type: 'success' | 'info' | 'warn';
}

let toastQueue: Array<(t: Toast) => void> = [];
let toastId = 0;

export function pushNotification(title: string, message: string, type: Toast['type'] = 'info') {
  const id = ++toastId;
  toastQueue.forEach((cb) => cb({ id, title, message, type }));
}

export function subscribeToasts(handler: (t: Toast) => void): () => void {
  toastQueue.push(handler);
  return () => {
    toastQueue = toastQueue.filter((cb) => cb !== handler);
  };
}
